import * as React from 'react';
import { PrimaryButton } from '@fluentui/react';
import styled from 'styled-components';

interface CookieConsentBannerProps {
  onAccept: () => void;
}
const Logo = styled.img`
  height: 75px;
  width: auto;
  user-select: none;
  pointer-events: none;
`;

export const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({ onAccept }) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        padding: '16px',
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
      }}
    >
      {/*<div>
        <Logo src="/Cookie.png" alt="Cookie" />
      </div>*/}
      <div>
        Мы используем файлы cookie для улучшения работы сайта.
      </div>
      <PrimaryButton  onClick={onAccept}>
        Принять
      </PrimaryButton>
    </div>
  );
};

